import type { Accountno } from '@shared/products-types';

export enum ACCOUNT_TYPE {
    TAX = 'TAX',
}

export interface AddressbookEntryAccount {
    accountNo: Accountno;
    accountType: ACCOUNT_TYPE;
}

export interface PublicContact {
    name: string;
    category: string;
    addressBookEntryAccount?: AddressbookEntryAccount[];
    contactId: string;
    image: string;
}
